import { formatAppRouter } from '@Core/Helpers/System'
import embedConfig from './Modules/Embed/configs'
import MyAccountConfig from './Modules/MyAccount/configs'
import { orderRouterConfig } from './Modules/Order/configs/router'

import SubcriptionConfig from './Modules/Subcription/configs'
import WorkspaceConfig from './Modules/Workspace/configs'
import PersonalConfig from './Modules/Personal/configs'
import { FcOnlineSupport } from 'react-icons/fc'
import { Policy, PrivacyTip } from '@mui/icons-material'
import { ROUTER_WORKSPACE_SYSTEM } from './Modules/Workspace/System/config/const'
export const appNavigationConfig = [...PersonalConfig.navigation, ...WorkspaceConfig.navigation]

export const studioRouterConfig = formatAppRouter([
	// ...AuthConfig.router,
	...embedConfig.router,
	...SubcriptionConfig.router,
	...WorkspaceConfig.router,
	...MyAccountConfig.router,
	...PersonalConfig.router,
	orderRouterConfig
])

export const footerNavigationConfig = [
	{
		id: 'suggest-feature',
		title: 'Điều khoản & chính sách',
		type: 'item',
		icon: <PrivacyTip fontSize="small" color="secondary" />,
		link: ROUTER_WORKSPACE_SYSTEM.policy
	},
	{
		id: 'contact-us',
		title: 'Hỗ trợ tư vấn',
		type: 'action',
		icon: <FcOnlineSupport className="text-[1.2rem]" />,
		onClick: ({ handleOpenContact }) => {
			handleOpenContact()
		}
	}
]
